import React from 'react'
import {ButtonLinkStyle, SelectField} from "../../../../Components/Inputs";
import {convertToCurrencyFormat} from "../AphQueue/aphQueueUtility";
import {getAvailabilityStatusList} from "./aphCatalogConstants";

interface AphResultsRowProps {
    aphResource: Record<string, any>;
    canManageAphCatalogItems: boolean;
    handleAddToQueue: (id: string) => void;
    handleEdit: (id: string) => void;
    onAvailabilityStatusClick: (catalogId: string, value: string) => void;
    updatedAvailabilityDropdowns?: string[];
}

export const AphResultsRow = ({
                                  aphResource,
                                  canManageAphCatalogItems,
                                  handleAddToQueue,
                                  handleEdit,
                                  onAvailabilityStatusClick,
                                  updatedAvailabilityDropdowns
                              }: AphResultsRowProps) => {

    const handleClickEdit = () => handleEdit(aphResource.id);
    const handleClickAddToQueue = () => handleAddToQueue(aphResource.id);

    const handleChangeAvailabilityStatus = (event: React.ChangeEvent<HTMLSelectElement>, catalogId: string) => {
        onAvailabilityStatusClick(catalogId, event.target.value);
    };

    const isUpdatedAvailabilityStatus = (resourceId: string) => {
        return updatedAvailabilityDropdowns && updatedAvailabilityDropdowns.includes(resourceId);
    }


    return <>
        <tr id={aphResource.catalogNumber} data-testid={aphResource.catalogNumber}>
            <td>
                {aphResource.catalogNumber}
            </td>
            <td>
                {aphResource.title}
            </td>
            <td>
                {`${convertToCurrencyFormat(aphResource.cost)}`}
            </td>
            {canManageAphCatalogItems &&
                <td className={`${isUpdatedAvailabilityStatus(aphResource.id) ? `pending` : ``}`}>


                    <SelectField
                        name={`availability-status-for-${aphResource.id}`}
                        value={aphResource.availabilityStatus}
                        options={getAvailabilityStatusList()}
                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => handleChangeAvailabilityStatus(e, aphResource.id)}
                        label={`Availability Status for ${aphResource.title}`}
                        hideLabel
                        includeDefaultOption={false}
                    />

                </td>
            }
            <td>
                {
                    canManageAphCatalogItems &&
                    <>
                        <ButtonLinkStyle
                            label={`Edit Item`}
                            name={`btnEdit${aphResource.id}`}
                            onClick={() => handleClickEdit()}/>

                        <span>&nbsp;&nbsp;&nbsp;</span>
                    </>
                }
                <ButtonLinkStyle
                    label={`Add to Queue`}
                    name={`btnAddQueue$${aphResource.id}`}
                    onClick={handleClickAddToQueue}/>

            </td>
        </tr>
    </>
}

